import styled from 'styled-components';
import { DefaultInput } from '../../styles/globals';


export const SimpleSearchInputCont = styled.div`
  position: relative;
  width: 100%;
`;

export const SimpleSearchInputComp = styled(DefaultInput)`
  position: relative;
  width: 100%;
  border: none;
  outline: none;
  box-sizing: border-box;
  padding: 0 0 0 44px;
  border-radius: 0;
  &:hover {
    border: none;
    outline: none;
  }
  &:focus {
    border: none;
  }
`;

export const IconCont = styled.div`
  display: flex;
  align-items: center;
  height: 48px;
  position: absolute;
  left: 15px;
  z-index: 100;
`;
